var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ height: _vm.size.h, width: _vm.size.w, transformOrigin: '0 0', transform: ("scale(" + _vm.mapScale + ")") }),attrs:{"id":"drillAMap"}})}
var staticRenderFns = []

export { render, staticRenderFns }